import React, {useState, useEffect, useImperativeHandle, forwardRef, useRef} from "react"
//需要传的参数
//groupListProps  回显的数据
//type 判断是创建还是编辑
//id 编辑进来的话需要这个活动的id
//选择群聊
import {Input, Checkbox, Button, DatePicker, Space, Table, Empty, Popover, Spin} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import ZkModal from "../modal/zkModal";
import CorpApi from "../../public/corp_api";
import ZkTable from "../table/zkTable";
import Message from "../message";
import moment from 'moment';
import groupHeadMapOne from "../../../images/groupHeadMap/1.png"
import groupHeadMapTwo from "../../../images/groupHeadMap/2.png"
import groupHeadMapThree from "../../../images/groupHeadMap/3.png"
import groupHeadMapFour from "../../../images/groupHeadMap/4.png"
import groupHeadMapFive from "../../../images/groupHeadMap/5.png"
import groupHeadMapSix from "../../../images/groupHeadMap/6.png"
import {DefaultUploadFile} from "../../cmpts/uploadfile";
import Util from "../../public/utils";
import Vars from "../../cmpts/system_vars";
import tag_empty from "../../../images/common/customer/tag/tag_empty.png";
import fissionFigure from "../../../images/fission/customer/activity/fissionFigure/fissionFigure.png";


const {RangePicker} = DatePicker;
let timer = null; //防抖 模糊查询
let scrollTimer = null; //滚动条
let pageNum = 1
let pages = null
let total = null
let inputValue =''
let scrollData=[]
let statusTimer = null //定时获取同步的状态
const ZkSelectGroupChat = forwardRef((props, ref) => {
    const [pageOption,setPageOption] = useState({
        pageNo:1,//当前页为1
        pageSize:10,//一页8行
    })
    const {groupListProps} = props//回显的表格的数 据
    const columns = [
        {
            title: '序号',
            dataIndex: 'order',
            key: 'order',
            // render: (text, record, index) => (
            //     <span>{index + 1}</span>
            // )
            render:(text,record,index)=> `${(pageOption.pageNo - 1) * 10 + (index +1)}`
        },
        {
            dataIndex: 'name',
            title: '群聊名称',
            width: '100px',
            render: (text, record, index) => (
                <div>
                    {
                        record.expireAt < moment(new Date().getTime() + 24 * 60 * 60 * 1000) ?
                            <div style={{color: 'red'}}>{record.groupName}</div> :
                            <div>{record.groupName}</div>
                    }
                    <div style={{color: '#959595', fontSize: '12px'}}>{record.memberNum}/{record.upperLimit}</div>
                </div>
            )
        },
        {
            dataIndex: 'name',
            title: '群二维码',
            render: (text, record, index) => (
                <div
                    className={`goods-upload-img upload-img-4 ${record.qrcodeUrl ? 'imgHeight' : ''}`}>
                    <div className={'add_img'}>
                        <div className='con'>
                            <span
                                className={record.qrcodeUrl ? 'imgReloadIcon' : 'imgIcon'}>
                            </span>
                            <p className={record.qrcodeUrl ? 'whiteTip' : ''}>{
                                record.qrcodeUrl ? '替换二维码' : '上传二维码'
                            }</p>
                        </div>
                    </div>
                    <img ref={image_uploadCustomer} className={'goodImg'}
                         src={record.qrcodeUrl}/>
                    <DefaultUploadFile btnText="上传二维码"
                                       selectFile={uploadCodeImg.bind(this, index,record.groupId)}
                                       accept="image/jpeg, image/png, image/jpg"
                                       className={'uploadCustomer'}/>
                </div>
            )
        },
        {
            dataIndex: 'expireAt',
            title: '二维码有效期',
            width: '200px',
            render: (text, record, index) => {
                return <Space direction="vertical" size={12}>
                    <DatePicker
                        className={record.expireAt && record.expireAt < moment(new Date().getTime() + 24 * 60 * 60 * 1000) ? 'expirationTime' : 'noExpirationTime'}
                        format="YYYY-MM-DD HH:mm:ss"
                        disabledDate={disabledDate}
                        showTime
                        onChange={dateOfQRCode.bind(this, record.groupId)}
                        defaultValue={record.expireAt ? moment(record.expireAt) : ''}
                    />
                </Space>
            }
        },
        {
            dataIndex: 'name',
            title: '群人数上限',
            render: (text, record) => (
                <>
                    <Input
                        // placeholder={record.upperLimit == 500 ? 480 : record.upperLimit == 300 ? 280 : ''}
                        placeholder={200}
                        value={record.fissionUpperLimit}
                        onChange={(e) => fissionUpperLimit(e, record.groupId)}
                    />
                </>
            )
        },
        {
            dataIndex: '',
            title: '操作',
            width: '150px',
            render: (text, record, index) => (
                <div>
                    <span className={`${(pageOption.pageNo - 1) * 10 + (index)}` == 0 ? 'group_list_move_up' : ''} onClick={() => moveUp(record,`${(pageOption.pageNo - 1) * 10 + (index +1)}`)}
                          style={{cursor: 'pointer', color: '#1673FF', marginRight: '10px'}}>上移</span>
                    <span className={`${(pageOption.pageNo - 1) * 10 + (index)}` == groupListTable.length - 1 ? 'group_list_shift_Down' : ''}
                          onClick={() => shiftDown(`${(pageOption.pageNo - 1) * 10 + (index +1)}`)}
                          style={{cursor: 'pointer', color: '#1673FF', marginRight: '10px'}}>下移</span>
                    <span onClick={() => deleteGroup(record.groupId, index)}
                          style={{cursor: 'pointer', color: '#1673FF', marginRight: '10px'}}>删除</span>
                </div>
            )
        }
    ]
    const paginationProps = {
        current:pageOption.pageNo,
        pageSize:pageOption.pageSize,
        onChange : (current)=> paginationChange(current,10)
    }
    const paginationChange = async (current,size)=>{
        setPageOption({
            pageNo: current,//当前所在页面
            pageSize:size,//一页有几行
        })
    }
    const selectGroup = useRef(null);//绑定弹框的ref
    const image_uploadCustomer = useRef(null)
    const [zkParams, setZkParams] = useState({name: '', status: 9});//表格变化
    const [groupList, setGroupList] = useState([]);//全部群聊数据
    // const [groupArray,setGroupArray]=useState(groupList);
    const [dateString, setDateString] = useState('');//存放批量设置的时间
    const [flag, setFlag] = useState(false);//设置批量设置时间的开关
    const [groupInput, setGroupInput] = useState('');//弹框的input值
    const [serial, setSerial] = useState(1);//序号
    const [expireAt, setExpireAt] = useState(null);//二维码有效期至
    const [qrcodeUrl, setQrcodeUrl] = useState('');//群二维码
    const [groupHeadMaps, setGroupHeadMaps] = useState([groupHeadMapOne, groupHeadMapTwo, groupHeadMapThree, groupHeadMapFour, groupHeadMapFive, groupHeadMapSix, groupHeadMapOne, groupHeadMapTwo, groupHeadMapThree, groupHeadMapFour]);//群聊的头图
    const [groupListTable, setGroupListTable] = useState(groupListProps.length > 0 ? groupListProps : []);//表格渲染数据
    const [deleteGroupChatID, setDeleteGroupChatID] = useState(null);//删除群聊的ID
    const deleteGroupID = useRef(null)//删除群聊的弹框绑定ref
    const [groupChatNameSearch, setGroupChatNameSearch] = useState('')//选择群聊弹框的input
    const [screen,setScreen]=useState(false) //筛选
    const [newData,setNewData]=useState([])
    const [syncChatStatus,setSyncChatStatus]=useState(true)
    const [newSelectGroup,setNewSelectGroup]=useState([])
    useEffect(() => {
        // console.log(groupListTable,'sfdsdfsdfsfdsdf')
    }, [groupListTable])

    useEffect(() => {
        if(groupListProps){
            let list = groupListProps
            list.forEach((item) => {
                item.flag = true
                item.expireAt=item.expireAt ? moment(item.expireAt) : null
            })
            setGroupListTable(list)
        }
    }, [groupListProps]);

    useEffect(() => {
        setGroupList(groupList)
    }, [groupList])

    useEffect(() => {
        let type
        let fissionId
        if (props.type) {
            type = props.type
        }
        if (type == 'edit') {
            fissionId = props.id
        } else {
            fissionId = ''
        }
    }, [props.id]);

    useEffect(() => {
        let name = ''
        let type
        let fissionId
        if (props.type) {
            type = props.type
        }
        if (type == 'edit') {
            fissionId = props.id
        } else {
            fissionId = ''
        }
            CorpApi.getGroupFissionGroupList(1,20,name, fissionId, (data) => {
                let list = data.list
                list.forEach((item, index) => {
                    if(groupListProps.length>0){
                        groupListProps && groupListProps.forEach((el) => {
                            if (el.groupId == item.groupId) {
                                item.flag = true
                                item.order =type == 'edit' ? null :  el.order
                                item.qrcodeUrl =type == 'edit' ? '' :  el.qrcodeUrl
                                item.expireAt =type == 'edit' ? null : (el.expireAt ? moment(el.expireAt) :null)
                            }
                        })
                        setNewSelectGroup(groupListProps)
                    }
                    item.img = groupHeadMaps[randomNumber()]
                    item.order = null,
                    item.qrcodeUrl = '',//二维码
                    item.expireAt = null//时间
                })
                total=data.pagInfo.total
                scrollData=list
                setGroupList(list)
            }, (error) => {
                Message.error('请求失败')
            })
    }, [groupListProps])


    useImperativeHandle(ref, () => ({
        getData: getData
    }));

    //表格中上传二维码的
    function uploadCodeImg(index,groupId, files) {
        // console.log(index,groupId,files,'9999')
        Util.uploadImage(files, Vars.DEFAULT_IMAGE_MAXSIZE(), (msg) => {
            $('.upload-img-4').css('height', 'auto');
            let shareImgUrl = msg.respMsg.url;
            let list = JSON.parse(JSON.stringify(groupListTable))
            list.forEach((item,ind)=>{
                if(item.groupId == groupId){
                    list[ind].qrcodeUrl = shareImgUrl
                    setGroupListTable(list)
                }
            })
        })
    }

    //点击选择群里按按钮弹框显示
    function SelectGroupBtns() {
        setScreen(false)
        selectGroup.current.show()
        //判断群聊是否同步完成
        CorpApi.getGroupFissionSyncGroupStatus((data)=>{
            setSyncChatStatus(false)
        },(error)=>{
            if(error.respCode == 40055){
                setSyncChatStatus(true)
                timeObtainStatus()
            }
        })
        setTimeout(()=>{
            if(document.querySelector('.selectGroup_group_chat_list')){
                document.querySelector('.selectGroup_group_chat_list') .addEventListener('scroll', handleScroll.bind(this))
            }
        },500)
    }
    function handleScroll(){
        const contentScrollTop = document.querySelector('.selectGroup_group_chat_list').scrollTop
        const clientHeight = document.querySelector('.selectGroup_group_chat_list').clientHeight
        const scrollHeight = document.querySelector('.selectGroup_group_chat_list').scrollHeight
        clearTimeout(scrollTimer)
        if(scrollHeight - (contentScrollTop + clientHeight) <= 150 ){
            scrollTimer=setTimeout(()=>{
                let fissionId
                if (props.type == 'edit') {
                    fissionId = props.id
                } else {
                    fissionId = ''
                }
                pageNum = pageNum+1
                CorpApi.getGroupFissionGroupList(pageNum,20,inputValue,fissionId,(data)=>{
                    let list = data.list
                    list.forEach((item, index) => {
                        if(groupListProps.length>0){
                            groupListProps.forEach((el) => {
                                if (item.groupId == el.groupId) {
                                    item.flag = true
                                    item.img = groupHeadMaps[randomNumber()]
                                    item.order =props.type == 'edit' ? null :  el.order
                                    item.qrcodeUrl =props.type == 'edit' ? '' :  el.qrcodeUrl
                                    item.expireAt =props.type == 'edit' ? null : (el.expireAt ? moment(el.expireAt) :null)
                                }
                            })
                        }
                        item.img = groupHeadMaps[randomNumber()]
                        item.order = null
                        item.qrcodeUrl = ''//二维码
                        item.expireAt = null//时间
                    })
                    total=data.pagInfo.total
                    scrollData=scrollData.concat(list)
                    setGroupList(scrollData)
                },()=>{})
            },500)
        }
    }

    //抛出表格的数据
    function getData() {
        let list = JSON.parse(JSON.stringify(groupListTable))
        return list
    }

    //群聊弹框的确认
    function saveGroup() {

        let Str = JSON.parse(JSON.stringify(groupList))
        let Arr = JSON.parse(JSON.stringify(groupListTable))
        let list = []
        list =
            screen ?
                Str.concat(Arr).filter(item => item.flag) :
                Str.filter(item => item.flag)
        // if(!screen){
        //     Arr.forEach((item)=>{
        //         Str.forEach((el,ind)=>{
        //             if(item.groupId != el.groupId){
        //                 list.push(item)
        //             }
        //         })
        //     })
        // }
        let newGroupListTable = []
        let a = []
        let b = []
        if(Arr.length != 0){
            Arr.forEach((item,index)=>{
                list.forEach((el,ind)=>{
                    if(item.groupId == el.groupId){
                        a.push(item)
                    }
                })
            })
        }
        list.forEach((item,index)=>{
            let exist =false;
            if(Arr.length !=0){
                Arr.forEach((el,ind)=>{
                    if(item.groupId == el.groupId){
                        exist = true;
                    }
                })
                if(!exist){
                    b.push(item)
                }
            }else {
                a.push(item)
            }
        })
        newGroupListTable = a.concat(b)
        setGroupListTable(Array.from(new Set(newGroupListTable)))
        selectGroup.current.hide()
    }

    //上移
    function moveUp(record,index) {
        index=index-1
        if (index == 0) {
            return
        } else {
            let tag = JSON.parse(JSON.stringify(groupListTable))
            if (index > 0) {
                tag[index] = tag.splice(index - 1, 1, tag[index])[0];
            } else {
                tag.push(tag.shift());
            }
            tag.forEach((item) => {
                if (item.expireAt == '') {
                    item.expireAt = null
                } else {
                    item.expireAt = item.expireAt
                }
            })
            setGroupListTable(tag)
        }

    }

    //下移
    function shiftDown(index) {
        index=index-1
        let tag = JSON.parse(JSON.stringify(groupListTable))
        if (index == tag.length - 1) {
            return ''
        } else {
            if (index != tag.length - 1) {
                tag[index] = tag.splice(index + 1, 1, tag[index])[0];
            } else {
                tag.unshift(tag.splice(index, 1)[0]);
            }
        }
        tag.forEach((item) => {
            if (item.expireAt == '') {
                item.expireAt = null
            } else {
                item.expireAt = item.expireAt
            }
        })
        setGroupListTable(tag)
    }

    //删除
    function deleteGroup(id, index) {
        setDeleteGroupChatID(id)//保存删除群聊的ID
        deleteGroupID.current.show()//打开删除群聊的弹框
    }

    //删群聊的弹框
    function deletaGroupIdOk() {
        let id = deleteGroupChatID;//获取删除群聊的id进行判断
        let list = JSON.parse(JSON.stringify(groupList));
        list.forEach((item, ind) => {
            if (item.groupId == id) {
                item.flag = false
            }
        })
        setGroupList(list)
        let newList = JSON.parse(JSON.stringify(groupListTable))
        let Arr = []
        newList.forEach((item) => {
            if (item.groupId != id) {
                Arr.push(item)
            }
        })
        setGroupListTable(Arr)
        deleteGroupID.current.hide()//关闭删除群聊的弹框
    }

    //裂变上限人数
    function fissionUpperLimit(e, id) {
        let list = JSON.parse(JSON.stringify(groupListTable))
        let rex = /^[0-9]*$/;
        let flag = rex.test(e.target.value)
        if (flag) {
            list.forEach((item) => {
                if (item.groupId == id) {
                    item.fissionUpperLimit = e.target.value
                    if (e.target.value == '') {
                        setGroupListTable(list)
                    } else {
                        if (item.fissionUpperLimit <= 0) {
                            item.fissionUpperLimit = 1
                        }
                        if (item.fissionUpperLimit <= 200) {
                            setGroupListTable(list)
                        } else {
                            Message.warning("群人数上限超过200");
                        }
                    }
                }
            })
        } else {
            Message.error("请输入数字");
        }
    }

    //单个二维码截止日期
    function dateOfQRCode(id, date, dateString) {
        let list = JSON.parse(JSON.stringify(groupListTable))
        list.forEach((item) => {
            if (item.groupId == id) {
                item.expireAt = date;
            }
        });
        setGroupListTable(list)
    }

    //批量设置日期选择
    function range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    //批量设置双向时间限制
    function disabledDate(current) {
        return current && (current < moment() || current > moment().subtract('days', -7))
    }

    //批量设置里面的时间变化事件
    function onChange(date, dateString) {
        setDateString(date)
    }

    //批量设置开关
    function volumeSetBtn() {
        setFlag(!flag)
    }

    //取消批量设置
    function cancelVolumeSetBtn() {
        setFlag(false)
    }

    //确认批量设置
    function affirmlVolumeSetBtn() {
        setFlag(false)
        let list = JSON.parse(JSON.stringify(groupListTable))
        list.forEach((item) => {
            item.expireAt = dateString
        })
        setGroupListTable(list)
    }

    //批量设置里面的复选框
    function groupHeadMapChange(id,item) {
        let list = JSON.parse(JSON.stringify(groupList))
        let str = []
        list.forEach((item) => {
            if (item.groupId == id) {
                item.flag = !item.flag
            }
            if(item.flag){
                str.push(item)
            }
        })
        setNewSelectGroup(str)
        scrollData=list
        setGroupList(list)
    }

    //弹框的input事件
    function groupInputChange(e) {
        let name = e.target.value
        inputValue=name
        setGroupInput(name)
        let type
        let fissionId
        if (props.type) {
            type = props.type
        }
        if (type == 'edit') {
            fissionId = props.id
        } else {
            fissionId = ''
        }
        clearTimeout(timer) //清除定时器
        timer = setTimeout(() => {
            CorpApi.getGroupFissionGroupList(1,20,name, fissionId, (data) => {
                console.log(groupListTable,'afsfasdsa')
                let list = data.list
                list.forEach((item, index) => {
                    newSelectGroup.forEach((el) => {
                        if (el.groupId == item.groupId) {
                            item.flag = true
                            item.order = el.order
                            item.qrcodeUrl = el.qrcodeUrl
                            item.expireAt = el.expireAt
                        }
                    })
                    item.img = groupHeadMaps[randomNumber()]
                    item.order = null,
                        item.qrcodeUrl = '',//二维码
                        item.expireAt = null//时间
                })
                if(list.length!=0){
                    groupListTable.forEach((item,index)=>{
                        list.forEach((el,ind)=>{
                            if(item.groupId == el.groupId){
                                el.flag = true
                            }
                        })
                    })
                }
                document.querySelector('.selectGroup_group_chat_list').scrollTop=0
                pageNum = 1
                setScreen(true)
                setGroupList(list)
                scrollData=list
            }, (error) => {
                Message.error('请求失败')
            })
        }, 500)
    }

    //定时获取同步的状态
    function timeObtainStatus (){
        clearInterval(statusTimer)
        statusTimer = setInterval(()=>{
            //获取同步状态
            CorpApi.getGroupFissionSyncGroupStatus((data)=>{
                //同步成功清除定时器
                setSyncChatStatus(false)
                clearInterval(statusTimer)
                let name = ''
                let type
                let fissionId
                if (props.type) {
                    type = props.type
                }
                if (type == 'edit') {
                    fissionId = props.id
                } else {
                    fissionId = ''
                }
                CorpApi.getGroupFissionGroupList(1,20,name, fissionId, (data) => {
                    let list = data.list
                    list.forEach((item, index) => {
                        groupListProps.forEach((el) => {
                            if (el.groupId == item.groupId) {
                                item.flag = true
                                item.order = el.order
                                item.qrcodeUrl = el.qrcodeUrl
                                item.expireAt = el.expireAt
                            }
                        })
                        item.img = groupHeadMaps[randomNumber()]
                        item.order = null,
                            item.qrcodeUrl = '',//二维码
                            item.expireAt = null//时间
                    })
                    document.querySelector('.selectGroup_group_chat_list').scrollTop=0
                    pageNum = 1
                    scrollData=list
                    setGroupList(list)
                }, (error) => {
                    Message.error('请求失败')
                })
            },(error)=>{
                //失败继续请求
                if(error.respCode == 40055){
                    setSyncChatStatus(true)
                    timeObtainStatus()
                }
            })
        },2000)
    }

    //刷新群聊
    function refreshTheGroupChat(id) {
        setSyncChatStatus(true)
        //先同步群聊
        CorpApi.getGroupFissionSyncGroupChatList((data)=>{
            setSyncChatStatus(false)
            let name = ''
            let type
            let fissionId
            if (props.type) {
                type = props.type
            }
            if (type == 'edit') {
                fissionId = props.id
            } else {
                fissionId = ''
            }
            CorpApi.getGroupFissionGroupList(1,20,name, fissionId, (data) => {
                let list = data.list
                list.forEach((item, index) => {
                    groupListProps.forEach((el) => {
                        if (el.groupId == item.groupId) {
                            item.flag = true
                            item.order = el.order
                            item.qrcodeUrl = el.qrcodeUrl
                            item.expireAt = el.expireAt
                        }
                    })
                    item.img = groupHeadMaps[randomNumber()]
                    item.order = null,
                        item.qrcodeUrl = '',//二维码
                        item.expireAt = null//时间
                })
                document.querySelector('.selectGroup_group_chat_list').scrollTop=0
                pageNum = 1
                scrollData=list
                setGroupList(list)
            }, (error) => {
                Message.error('请求失败')
            })
        },(error)=>{
            if(error.respCode == 40055){
                setSyncChatStatus(true)
                timeObtainStatus() //延时调用
            }
        })


    }

    //随机获取0~9之间的整数
    function randomNumber() {
        let num;
        num = Math.floor(Math.random() * 10)
        return num
    }

    return (
        <div className={'select_group_chat'}>
            <div className={'select_group_chat_button'}>
                <Button onClick={SelectGroupBtns.bind(this)} type="primary" ghost>请选择群聊</Button>
                {
                    groupListTable.length > 0 ? <div onClick={volumeSetBtn.bind(this)}>批量设置</div> : ''
                }
            </div>
            <div
                className={flag ? 'select_group_chat_button_time_mc_open select_group_chat_button_time_mc' : 'select_group_chat_button_time_mc select_group_chat_button_time_mc_clone'}>
                <div>
                    <span>二维码有效期：</span>
                    <Space direction="vertical" size={12}>
                        <DatePicker
                            format="YYYY-MM-DD hh:mm:ss"
                            disabledDate={disabledDate}

                            showTime
                            onChange={onChange}
                            value={dateString ? moment(dateString) : null}
                        />
                    </Space>
                </div>
                <div>
                    <Button type="primary" ghost onClick={cancelVolumeSetBtn.bind(this)}>取消</Button>
                    <span style={{width: '10px', display: 'inline-block'}}></span>
                    <Button type="primary" ghost style={{marginRight: '20px'}}
                            onClick={affirmlVolumeSetBtn.bind(this)}>确认</Button>
                </div>
            </div>
            <div className={'select_group_table'}>
                <Table columns={columns} params={zkParams} dataSource={groupListTable} hideOnSinglePage={true} rowKey={record => record} pagination={paginationProps}/>
            </div>
            <ZkModal title={'选择群聊'} ref={selectGroup} onOk={saveGroup.bind(this)}
                     afterClose={()=>clearInterval(statusTimer)}>
                <Input
                    placeholder="请输入群名称"
                    prefix={<SearchOutlined style={{color: '#BEBEBE'}}/>}
                    className={'select_group_input'}
                    onChange={groupInputChange}
                />
                <div className={'selectGroup_allGroup'}>全部群聊（{total}）
                    <span>
                        <Button loading={syncChatStatus}
                                type="primary"
                                ghost
                                size={'small'}
                                onClick={refreshTheGroupChat.bind(this, props.id)}>
                            同步群聊
                        </Button>
                    </span>
                    {/*<span className={syncChatStatus == false ? 'forbidden' : ''}*/}
                    {/*      onClick={syncChatStatus ?refreshTheGroupChat.bind(this, props.id) : null}>*/}
                    {/*    同步群聊*/}
                    {/*</span>*/}
                </div>
                <div className={'selectGroup_group_chat_list'}>
                    <div className={'new_all_group_scroll'}>
                        {
                            groupList.length == 0 ? <div style={{marginTop: '12px', fontWeight: '600'}}>
                                <Empty image={tag_empty} description={'没有搜到相关的群聊哦~'}></Empty>
                            </div> : <>
                                {
                                    groupList && groupList.map((item, index) => {
                                        return <div key={item.groupId} className={'selectGroup_group_chat_lists'}
                                                    style={item.hasBinding == 1 || item.memberNum >= 200 ? {
                                                        opacity: '0.6',
                                                        cursor: 'not-allowed'
                                                    } : {}}>
                                            <label>
                                                <div className={'selectGroup_group_chat_list_left'}>
                                                    {/*<img src={groupHeadMaps[randomNumber()]}/>*/}
                                                    {
                                                        item.hasBinding == 1 ?
                                                            <Popover placement="top" content={<div>
                                                                <span>该群聊已用于其他群裂变活动，不能添加</span>
                                                            </div>}><img src={item.img}/>
                                                            </Popover> :
                                                            item.memberNum >=200 ?
                                                                <Popover placement="top" content={<div>
                                                                    <span>该群聊扫码人数超过200人上限，不能添加</span>
                                                                </div>}><img src={item.img}/>
                                                                </Popover> : <img src={item.img}/>
                                                    }
                                                    <div>
                                                        <div>{item.groupName}<span style={item.hasBinding == 1 || item.memberNum >= 200 ? {
                                                            color: '#B3B3B3',
                                                            border: "1px solid #D9D9D9"
                                                        } : {}}>外部</span></div>
                                                        <div>{item.memberNum}/{item.upperLimit}</div>
                                                    </div>
                                                </div>
                                                <div className={'selectGroup_group_chat_list_right'}>
                                                    <Checkbox onChange={groupHeadMapChange.bind(this, item.groupId,item)}
                                                              disabled={item.hasBinding == 1 ? true : item.memberNum > 199 ? true : false}
                                                              checked={item.flag}/>
                                                </div>
                                            </label>

                                        </div>
                                    })
                                }
                            </>
                        }
                    </div>
                </div>
            </ZkModal>
            <ZkModal title={'删除规则'} ref={deleteGroupID} onOk={deletaGroupIdOk.bind(this)}>
                <div>确定删除此群聊吗？删除后不可恢复</div>
            </ZkModal>
        </div>
    )
});
export default ZkSelectGroupChat